import WebSocketClient from '@clients/web-socket.client';
import { ICreateFlowPost, ICreateFlowPostComment, ILikeFlowPost, ISeenFlowPost, IRequestFlowPosts } from '@app-types/websocket/imageflow.types';

const socket = WebSocketClient.getInstance();

export function imageFlowCreate(data:ICreateFlowPost) {
  socket.sendJSON({
    imageFlowCreate: data,
  });
}
export function imageFlowDelete(data:number) {
  socket.sendJSON({
    imageFlowDelete: data,
  });
}
export function imageFlowCommentCreate(data:ICreateFlowPostComment) {
  socket.sendJSON({
    imageFlowCommentCreate: data,
  });
}
export function imageFlowLike(data:ILikeFlowPost) {
  socket.sendJSON({
    imageFlowLike: data,
  });
}
export function imageFlowSeen(data:ISeenFlowPost) {
  socket.sendJSON({
    imageFlowSeen: data,
  });
}
export function imageFlowRequest(data:IRequestFlowPosts) {
  socket.sendJSON({
    imageFlowRequest: data,
  });
}




// WEBPACK FOOTER //
// ./src/services/imageflow/imageflow.websocket.ts